export { default } from './SWArticleCard';
